import { render, staticRenderFns } from "./OrderListLoader.vue?vue&type=template&id=0bd0a8ea&scoped=true&"
import script from "./OrderListLoader.vue?vue&type=script&lang=js&"
export * from "./OrderListLoader.vue?vue&type=script&lang=js&"
import style0 from "./OrderListLoader.vue?vue&type=style&index=0&id=0bd0a8ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd0a8ea",
  null
  
)

export default component.exports